import React from "react";
import { currentLocals } from "../languages/languages.js";
import "../styles/OnBoarding.css";

import { Typography } from "@mui/material";

function ShowsOrHideImages(Step) {
  var imgDownloadImg = document.getElementById("DownloadImg");
  var imgViewPAView = document.getElementById("ViewPAConversion");
  switch (Step) {
    case 4:
      imgViewPAView.classList.remove("tourViewPAConversionListHide");
      imgViewPAView.classList.add("tourViewPAConversionListShow");
      imgDownloadImg.classList.add("tourDownloadConversionListHide");
      imgDownloadImg.classList.remove("tourDownloadConversionListShow");
      break;
    case 5:
      imgViewPAView.classList.add("tourViewPAConversionListHide");
      imgViewPAView.classList.remove("tourViewPAConversionListShow");
      imgDownloadImg.classList.remove("tourDownloadConversionListHide");
      imgDownloadImg.classList.add("tourDownloadConversionListShow");
      break;
    default:
      imgViewPAView.classList.add("tourViewPAConversionListHide");
      imgViewPAView.classList.remove("tourViewPAConversionListShow");
      imgDownloadImg.classList.add("tourDownloadConversionListHide");
      imgDownloadImg.classList.remove("tourDownloadConversionListShow");
      break;
  }
}

function getTourSteps(locale) {
  locale = locale === undefined ? "EN" : locale;

  let tourConfig = [
    {
      selector: '[data-tut="reactour__converterspannel"]',
      position: "right",
      content: function DemoHelperComponent_1() {
        return (
          <div>
            <Typography sx={{ marginRight: 2, color: "primary.main" }} variant="h4">
              {currentLocals(locale).Tour.Title1}
            </Typography>
            {/*<div className="tourdefaultfonttitle">{currentLocals(locale).Tour.Title1}</div>*/}
            <br />
            <div className="tourdefaultfont">{currentLocals(locale).Tour.Info1}</div>
          </div>
        );
      },
      action: () => ShowsOrHideImages(1),
    },
    {
      selector: '[data-testid="muiheader-preferences-header-icon"]',
      position: "right",
      content: function DemoHelperComponent_3() {
        return (
          <div>
            <Typography sx={{ marginRight: 2, color: "primary.main" }} variant="h4">
              {currentLocals(locale).Tour.Title2}
            </Typography>
            {/*<div className="tourdefaultfonttitle">{currentLocals(locale).Tour.Title2}</div>*/}
            <br />
            <div className="tourdefaultfont">{currentLocals(locale).Tour.Info2_1}</div>
            <br />
            <div className="tourdefaultfont">{currentLocals(locale).Tour.Info2_2}</div>
          </div>
        );
      },
      action: () => ShowsOrHideImages(2),
    },
    {
      selector: '[data-tut="reactour__converterspool"]',
      position: "left",
      content: function DemoHelperComponent_2() {
        return (
          <div>
            <Typography sx={{ marginRight: 2, color: "primary.main" }} variant="h4">
              {currentLocals(locale).Tour.Title3}
            </Typography>
            {/* <div className="tourdefaultfonttitle">{currentLocals(locale).Tour.Title3}</div> <br />*/}
            <br />
            <div className="tourdefaultfont">{currentLocals(locale).Tour.Info3}</div>
          </div>
        );
      },
      action: () => ShowsOrHideImages(3),
      roundedStep: true,
    },

    {
      selector: '[data-tut="reactour__whatisnewViewPaternAssistant"]',
      position: "top",
      content: function DemoHelperComponent_4() {
        return (
          <div>
            <Typography sx={{ marginRight: 2, color: "primary.main" }} variant="h4">
              {currentLocals(locale).Tour.Title4}
            </Typography>
            {/*<div className="tourdefaultfonttitle">{currentLocals(locale).Tour.Title4}</div> <br />*/}
            <br />
            <div className="tourdefaultfont">{currentLocals(locale).Tour.Info4_1}</div>
            <div className="tourdefaultfont">{currentLocals(locale).Tour.Info4_2}</div>
          </div>
        );
      },
      action: () => ShowsOrHideImages(4),
    },
    {
      selector: '[data-tut="reactour__conversionbardownloadimage"]',
      position: "top",
      content: function DemoHelperComponent_5() {
        return (
          <div>
            <Typography sx={{ marginRight: 2, color: "primary.main" }} variant="h4">
              {currentLocals(locale).Tour.Title5}
            </Typography>
            {/* <div className="tourdefaultfonttitle">{currentLocals(locale).Tour.Title5}</div> <br />*/}
            <br />
            <div className="tourdefaultfont">{currentLocals(locale).Tour.Info5}</div>
          </div>
        );
      },
      action: () => ShowsOrHideImages(5),
    },
    /*
    {
      selector: '[data-testid="muiheader-help-header-icon"]',
      content: function DemoHelperComponent_6() {
        return (
          <div>
            {" "}
            <div className="tourdefaultfonttitle">{currentLocals(locale).Tour.Title6}</div> <br />
            <div className="tourdefaultfont">{currentLocals(locale).Tour.Info6}</div>
          </div>
        );
      },
      action: () => ShowsOrHideImages(6),
    },*/
    {
      //selector: '[data-tut="reactour__conversionhelpbutton"]',
      selector: '[data-testid="muiheader-help-header-icon"]',
      content: function DemoHelperComponent_7() {
        return (
          <div>
            <Typography sx={{ marginRight: 2, color: "primary.main" }} variant="h4">
              {currentLocals(locale).Tour.Title7}
            </Typography>
            {/*<div className="tourdefaultfonttitle">{currentLocals(locale).Tour.Title7}</div> */}
            <br />
            <div className="tourdefaultfont">{currentLocals(locale).Tour.Info7}</div>
          </div>
        );
      },
      action: () => ShowsOrHideImages(7),
    },
    /*
    {
      selector: '[data-tut="reactour__center"]',
      position: "center",
      content: function DemoHelperComponent_8() {
        return (
          <div>
            {" "}
            <div className="tourdefaultfonttitle">{currentLocals(locale).Tour.Title8}</div> <br />
            <div className="tourdefaultfont">{currentLocals(locale).Tour.Info8}</div>
          </div>
        );
      },
      action: () => oculta(),
    },*/
  ];

  return tourConfig;
}

export default getTourSteps;
